import React from 'react'
import Logo from "../../logo.svg";
import './loading.css'

export default function Loading(props) {
  return (
    <div {...props} className='PDFCotw'>
      <img className='App-logo' src={Logo} alt="Logo"/>
    </div>
  )
}
